import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { LandlordRenterInfoResourcePackage } from "../resources/LandlordRenterInfoResourcePackage";

export class RenterInfoFrame extends Container {

    public constructor(landlordRenterInfoResources: LandlordRenterInfoResourcePackage) {
        super();
        const frame = new Sprite(landlordRenterInfoResources.assets_views_landlord_renter_info_images_renter_info_frame_png);
        this.addChild(frame)
        const icon = new Sprite(landlordRenterInfoResources.assets_views_landlord_renter_info_images_renter_icon_png);
        icon.position.set(67.44, -120.58);
        this.addChild(icon);
        const text = new Text(landlordRenterInfoResources.assets_views_landlord_renter_info_text_renter_info_txt, new FrameInfoTextStyle());
        text.position.set(31, 138.42);
        this.addChild(text);
    }
}

class FrameInfoTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "left",
            fill: "#ffffff",
            fontFamily: GameFont.Bebasneuepro_Smerg,
            fontSize: 32,
            lineHeight: 37.5
        }));
    }
}
